const level: any = {};

export function CEFRlevelmap(course: number) {
  switch (course) {
    case 0:
      level.cefr = "A1";
      level.cefrHalfLevel = "A1.1";
      level.courseLevel = "A1.1";
      break;
    case 1:
      level.cefr = "A1";
      level.cefrHalfLevel = "A1.2";
      level.courseLevel = "A1.2";
      break;
    case 2:
      level.cefr = "A2";
      level.cefrHalfLevel = "A2.1";
      level.courseLevel = "A2.1";
      break;
    case 3:
      level.cefr = "A2";
      level.cefrHalfLevel = "A2.1";
      level.courseLevel = "A2.2";
      break;
    case 4:
      level.cefr = "A2";
      level.cefrHalfLevel = "A2.2";
      level.courseLevel = "B1.1";
      break;
    case 5:
      level.cefr = "B1";
      level.courseLevel = "B1.1";
      level.cefrHalfLevel = "B1.1";
      break;
    case 6:
      level.cefr = "B1";
      level.cefrHalfLevel = "B1.1";
      level.courseLevel = "B1.2";
      break;
    case 7:
      level.cefr = "B1";
      level.cefrHalfLevel = "B1.2";
      level.courseLevel = "B2.1";
      break;
    case 8:
      level.cefr = "B2";
      level.cefrHalfLevel = "B2.1";
      level.courseLevel = "B2.2";
      break;
    case 9:
      level.cefr = "B2";
      level.cefrHalfLevel = "B2.2";
      level.courseLevel = "C1.1";
      break;
    case 10:
      level.cefr = "C1";
      level.cefrHalfLevel = "C1.1";
      level.courseLevel = "C1.2";
      break;
    default:
      level.cefr = "NIL";
      level.cefrHalfLevel = "NIL";
      level.courseLevel = "NIL";
      break;
  }
  return level;
}

let NextLevel: any = "";
export function CEFRNextLevelmap(courseLevel: string) {
  switch (courseLevel) {
    case "A1.1":
      NextLevel = "A1.2";
      break;
    case "A1.2":
      NextLevel = "A2.1";
      break;
    case "A2.1":
      NextLevel = "A2.2";
      break;
    case "A2.2":
      NextLevel = "B1.1";
      break;
    case "B1.1":
      NextLevel = "B1.2";
      break;
    case "B1.2":
      NextLevel = "B2.1";
      break;
    case "B2.1":
      NextLevel = "B2.2";
      break;
    case "B2.2":
      NextLevel = "NIL";
      break;
    case "C1.1":
      NextLevel = "NIL";
      break;
    default:
      NextLevel = "NIL";
      break;
  }
  return NextLevel;
}

export const getUserNextAssessmentLevel = (courseLevel: string) => {
  switch (courseLevel) {
    case "A1.1":
      return "A1.2";
    case "A1.2":
      return "A2.1";
    case "A2.1":
      return "A2.2";
    case "A2.2":
      return "B1.1";
    case "B1.1":
      return "B1.2";
    case "B1.2":
      return "B2.1";
    case "B2.1":
      return "B2.2";
    case "B2.2":
      return "C1.1";
    case "C1.1":
      return "C1.2";
    case "C1.2":
      return "C2.1";
    case "C2.1":
      return "C2.2";
    case "C2.2":
      return "NIL";
    default:
      return "NIL";
  }
};

export function getLevelUserLevel(courseLevel: string) {
  switch (courseLevel) {
    case "A1.1":
      return "Elementary";
    case "A1.2":
      return "Elementary";
    case "A2.1":
      return "Pre-Intermediate";
    case "A2.2":
      return "Pre-Intermediate";
    case "B1.1":
      return "Intermediate";
    case "B1.2":
      return "Intermediate";
    case "B2.1":
      return "Upper-Intermediate";
    case "B2.2":
      return "Upper-Intermediate";
    case "C1.1":
      return "Advanced";
  }
}

export function getSkillsUserLevel(courseLevel: string) {
  switch (courseLevel) {
    case "A0.1":
      return "Absolute Beginner";
    case "A0.2":
      return "Absolute Beginner";
    case "A1.1":
      return "Beginner";
    case "A1.2":
      return "Beginner";
    case "A2.1":
      return "Lower Intermediate";
    case "A2.2":
      return "Lower Intermediate";
    case "B1.1":
      return "Higher Intermediate";
    case "B1.2":
      return "Higher Intermediate";
    case "B2.1":
      return "Advanced";
    case "B2.2":
      return "Advanced";
    case "C1.1":
      return "Advanced";
    default:
      return "";
  }
}

export const tempSoloCourseLevel = (userLevel: string) => {
  switch (userLevel) {
    case "A1.1":
      return "A1.1";
    case "A1.2":
      return "A1.1";
    case "A2.1":
      return "A2.1";
    case "A2.2":
      return "A2.1";
    case "B1.1":
      return "B1.1";
    case "B1.2":
      return "B1.1";
    case "B2.1":
      return "B2.2";
    case "B2.2":
      return "B2.2";
    case "C1.1":
      return "B2.2";
    default:
      return "";
  }
};

export const getSoloCourseLevel = (userLevel: string) => {
  switch (userLevel) {
    case "A1.1":
      return "A1.2";
    case "A1.2":
      return "A2.1";
    case "A2.1":
      return "A2.2";
    case "A2.2":
      return "B1.1";
    case "B1.1":
      return "B1.2";
    case "B1.2":
      return "B2.1";
    case "B2.1":
      return "B2.2";
    case "B2.2":
      return "B2.2";
    case "C1.1":
      return "B2.2";
    default:
      return "";
  }
};
